import ProfileMenuButton from '../../../components/commoncomponents/ProfileMenuButton';

function Header({ user, onLogout, onOpenProfile }) {
  const accessLabel = user?.user_type === 0 ? 'superadmin' : 'admin';

  return (
    <header className="flex flex-col gap-3 border-b border-[#ece6df] pb-5 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <p className="m-0 text-sm text-[#93857b]">Logged in as {accessLabel}</p>

      <ProfileMenuButton user={user} onLogout={onLogout} onOpenProfile={onOpenProfile} />
    </header>
  );
}

export default Header;
